import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import ServicesSection from "@/sections/ServicesSection";
import ApproachTimeline from "@/sections/ApproachTimeline";
import WhoWeWorkWith from "@/sections/WhoWeWorkWith";
import ClientsSection from "@/sections/ClientsSection";
import AboutSection from "@/sections/AboutSection";
import CTABlock from "@/components/CTABlock";

const MARQUEE = [
  "Positioning",
  "Systems",
  "Automation",
  "AI Workflows",
  "Strategy",
  "Growth",
];

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee items={MARQUEE} />
      <ServicesSection />
      <ApproachTimeline />
      <WhoWeWorkWith />
      <ClientsSection />
      <AboutSection />
      <CTABlock />
    </div>
  );
}
